exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zanbtndiv[data-v-36180886]{cursor:pointer;margin-left:16px}.zanbtndiv img[data-v-36180886]{width:16px;height:16px}.zanbtndiv .btntext[data-v-36180886]{margin-left:4px;font-size:12px;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36180886","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/packages/zan/um-zan.vue
// module id = 96
// module chunks = 0